// Redux Module Available
import iframeReducer from "./mods/iframe/redux/reducers/index";
import navControlReducer from "../../nav-control/redux/reducers/index";
import automixReducer from "../../automix/redux/reducers/index";
import shortcutReducer from "../../shortcut/redux/reducers/index";
import cartReducer from "../../cart/redux/reducers/index";

// Enable Redux Module
const customReducers = [
  iframeReducer,
  navControlReducer,
  automixReducer,
  shortcutReducer,
  cartReducer
];

export default customReducers;
